<button type="button" class="btn btn-primary" id="openLanguagePreference" [hidden]="true" data-toggle="modal"
    data-target="#openLanguagePreferenceModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="openLanguagePreferenceModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header popup-header">
                <h5 class="modal-title" id="languagePreferenceTitle">User Language Preferences</h5>
                <button id="closeLanguagePreference" type="button" class="close" [hidden]="false"
                    (click)="initUpdateLanguagePreferrencesModel(); callRouteToHomeEmitter();" data-dismiss="modal"
                    aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>

            <form #updateLanguagePreferrencesForm="ngForm" novalidate
                (ngSubmit)="updateLanguagePreferrences(updateLanguagePreferrencesForm)">
                <div class="modal-body">
                    <div class="row p-3">
                        <div class="col-12 mt-4">
                            <div><label>Do you want to set language preference?</label></div>
                        </div>

                        <div class="col-12 mt-4">
                            <div class="form-group">
                                <div>
                                    <div *ngFor="let supportedLanguage of allSupportedLanguages; let i = index"
                                        class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" name="checkbox" class="custom-control-input"
                                            [disabled]="false" id="language_{{i}}"
                                            [checked]="supportedLanguage.ischecked"
                                            (change)="onLanguageSelected($event.target.checked, i)">
                                        <label class="custom-control-label"
                                            for="language_{{i}}">{{supportedLanguage.language}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <div>
                        <button type="submit" class="btn btn-primary border pull-right btn-80">Update</button>
                        <button type="button" (click)="initUpdateLanguagePreferrencesModel(); callRouteToHomeEmitter()"
                            class="btn btn-light btn-80 border pull-right mr-2" data-dismiss="modal">CANCEL</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>